import { Configuration } from "./configuration.model";
import { TemplateInterface } from './template.model';

export class Property implements PropertyInterface {
    _id: string = "";
    _client_id: string = "";
    name: string = "New Property";
    title: string = "New Property";
    clean_template_id: number = -1;
    clean_template_public: string = "";
    hostname: string = "google.ca";
    dirty_url: string = "https://google.ca";
    redirect_url: string = "https://google.ca";
    redirect: boolean = true;
    icon: string = "feather";
    configuration: Configuration;
    template: TemplateInterface;

    constructor(raw: PropertyInterface) {
        Object.assign(this, raw);
        this.configuration = new Configuration(raw.configuration);

        //Sanitize dirty url for rtfb
        const websiteDomainRegex: RegExp = /([a-zA-Z0-9])([a-zA-Z0-9-+%]+\.)?([a-z-A-Z0-9])([a-zA-Z0-9-+%]+)\.(\w){2,4}(\.(\w){2,2})?$/gm;
        const matches = websiteDomainRegex.exec(this.dirty_url);
        if (matches && matches.length > 0) {
            this.dirty_url = matches[0];
            this.dirty_url = this.dirty_url.replace('.', '(dot)');
            console.log(`Setting dirty URL to ${this.dirty_url}`);
        }
    }
}

export interface PropertyInterface {
    _id: string;
    _client_id: string;
    name: string;
    title: string;
    clean_template_id: number;
    clean_template_public: string;
    hostname: string;
    redirect_url: string;
    redirect: boolean;
    dirty_url: string;
    icon: string;
    configuration: Configuration;
    template: TemplateInterface;
}


